// Home.jsx
import React, { useState, useEffect } from 'react';
import { 
  FaFacebook, 
  FaTwitter, 
  FaYoutube, 
  FaLinkedin, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaPlay,
  FaUsers,
  FaHandsHelping,
  FaSeedling,
  FaCoffee,
  FaArrowRight,
  FaBars,
  FaTimes,
  FaChevronUp,
  FaRegClock,
  FaUserCircle,
  FaEye,
  FaTag,
  FaQuoteRight,
  FaVideo,
  FaNewspaper,
  FaRegCalendarAlt
} from 'react-icons/fa';

const Home = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  // Mock News Data - Ethiopian Cooperative Context
  const newsData = [
    {
      id: 1,
      title: "Ethiopian Coffee Farmers Cooperative Reports Record Export",
      excerpt: "Over 50,000 coffee farmers across Oromia region benefit from record coffee exports to international markets, with earnings increasing by 35% this quarter.",
      date: "2024-01-15",
      category: "Agriculture",
      image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      author: "Ministry of Agriculture",
      readTime: "3 min read"
    },
    {
      id: 2,
      title: "New Dairy Processing Facility Opens at Fara Hiyyumma",
      excerpt: "Union of 15 dairy cooperatives inaugurates state-of-the-art processing facility to serve over 100,000 members, creating 500 new jobs.",
      date: "2024-01-12",
      category: "Industry",
      image: "https://images.unsplash.com/photo-1628085662857-70268223f5e0?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      author: "Ethiopian Cooperative Commission",
      readTime: "4 min read"
    },
    {
      id: 3,
      title: "Women-Led Teff Cooperative Wins International Award",
      excerpt: "Amhara region women's cooperative recognized for sustainable farming practices and community development at the UN Food Systems Summit.",
      date: "2024-01-10",
      category: "Award",
      image: "https://images.unsplash.com/photo-1600518464441-9154a4dea21b?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      author: "UN Women Ethiopia",
      readTime: "2 min read"
    },
    {
      id: 4,
      title: "Digital Training Program Launched for 200 peopels at Fara Hiyyumma",
      excerpt: "New initiative to train cooperative leaders in digital financial management and record-keeping, funded by Mastercard Foundation.",
      date: "2024-01-08",
      category: "Training",
      image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      author: "Mastercard Foundation",
      readTime: "3 min read"
    },
    {
      id: 5,
      title: "Sidama Coffee Cooperative Expands to European Market",
      excerpt: "Direct trade agreement signed with roasters in Germany and Sweden benefiting 25,000 farmers with premium prices.",
      date: "2024-01-05",
      category: "Trade",
      image: "https://images.unsplash.com/photo-1442512595331-e89e73853f31?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      author: "Ethiopian Coffee Exchange",
      readTime: "4 min read"
    },
    {
      id: 6,
      title: "Irrigation Project Benefits 10,000 Smallholder Farmers",
      excerpt: "New irrigation system in Sheger helps farmers diversify crops and increase yield by 40%.",
      date: "2024-01-03",
      category: "Development",
      image: "https://images.unsplash.com/photo-1507480553829-5dae4c9d2cf2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      author: "UNDP Ethiopia",
      readTime: "3 min read"
    }
  ];

  // Mock Activities Data - Recent and Upcoming
  const activitiesData = [
    {
      id: 1,
      title: "Annual General Meeting - All Unions",
      description: "Join the annual general meeting of all 327 cooperative unions to discuss strategy, review performance, and elect new leadership for the upcoming term.",
      date: "2024-02-15",
      time: "9:00 AM - 5:00 PM",
      location: "Addis Ababa Convention Center",
      type: "meeting",
      attendees: 1500,
      status: "upcoming",
      registrationDeadline: "2024-02-10"
    },
    {
      id: 2,
      title: "Coffee Export Training Workshop",
      description: "Comprehensive training on quality control, packaging standards, international marketing, and export documentation for coffee cooperatives.",
      date: "2024-01-25",
      time: "10:00 AM - 4:00 PM",
      location: "Jimma University",
      type: "training",
      attendees: 200,
      status: "upcoming",
      registrationDeadline: "2024-01-20"
    },
    {
      id: 3,
      title: "Financial Literacy Program",
      description: "Week-long training on budgeting, savings, access to credit, and financial planning for cooperative members and their families.",
      date: "2024-01-18",
      time: "9:00 AM - 3:00 PM",
      location: "Hawassa Cooperative College",
      type: "workshop",
      attendees: 350,
      status: "ongoing",
      registrationDeadline: "2024-01-15"
    },
    {
      id: 4,
      title: "Women in Leadership Conference",
      description: "Empowering women leaders in cooperatives across Ethiopia with networking opportunities, mentorship, and skill-building sessions.",
      date: "2024-02-05",
      time: "8:30 AM - 6:00 PM",
      location: "Sheraton Addis Hotel",
      type: "conference",
      attendees: 500,
      status: "upcoming",
      registrationDeadline: "2024-01-30"
    },
    {
      id: 5,
      title: "Harvest Festival Exhibition",
      description: "Showcasing products from cooperative unions across all regions including coffee, grains, dairy, honey, and traditional crafts.",
      date: "2024-01-20",
      time: "10:00 AM - 8:00 PM",
      location: "Millennium Hall, Addis Ababa",
      type: "exhibition",
      attendees: 5000,
      status: "ongoing",
      registrationDeadline: "2024-01-18"
    },
    {
      id: 6,
      title: "Digital Transformation Workshop",
      description: "Introduction to the new Cooperative Management System for union administrators, featuring hands-on training and Q&A sessions.",
      date: "2024-02-10",
      time: "9:00 AM - 5:00 PM",
      location: "Online (Zoom)",
      type: "training",
      attendees: 300,
      status: "upcoming",
      registrationDeadline: "2024-02-05"
    }
  ];

  // Mock Videos Data - Ethiopian Cooperative Content
  const videosData = [
    {
      id: 1,
      title: "Farra Hiyyumma on Coffee",
      description: "Follow the journey of coffee through the Sidama Coffee Farmers Cooperative Union, from harvesting to export.",
      thumbnail: "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      duration: "12:45",
      views: "15K",
      date: "2024-01-10",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ", // Replace with actual video
      category: "Documentary",
      author: "Ethiopian Coffee Exchange"
    },
    {
      id: 2,
      title: "How Cooperatives Transform Communities",
      description: "Success stories from women-led cooperatives in the Amhara region and their impact on local development.",
      thumbnail: "https://images.unsplash.com/photo-1593113598338-cd288d649433?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      duration: "18:30",
      views: "23K",
      date: "2024-01-05",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ", // Replace with actual video
      category: "Impact Story",
      author: "UN Women"
    },
    {
      id: 3,
      title: "Modern Farming Techniques in SHeger City",
      description: "Training video for cooperative members on sustainable agriculture, irrigation, and crop rotation.",
      thumbnail: "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      duration: "25:15",
      views: "31K",
      date: "2023-12-28",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ", // Replace with actual video
      category: "Educational",
      author: "Ministry of Agriculture"
    },
    {
      id: 4,
      title: "Annual Cooperative Summit 2023 Highlights",
      description: "Key moments and speeches from the largest cooperative gathering in Ethiopia with over 2,000 participants.",
      thumbnail: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      duration: "8:20",
      views: "42K",
      date: "2023-12-20",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ", // Replace with actual video
      category: "Event",
      author: "ECA"
    },
    {
      id: 5,
      title: "Empowering Women Through Cooperatives",
      description: "Documentary featuring female entrepreneurs in the Oromia region and their journey to economic independence.",
      thumbnail: "https://images.unsplash.com/photo-1573164713988-9665a4f1c184?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      duration: "15:40",
      views: "19K",
      date: "2023-12-15",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ", // Replace with actual video
      category: "Documentary",
      author: "UNDP"
    },
    {
      id: 6,
      title: "Youth in Agriculture: Future of Cooperatives",
      description: "Young farmers share their vision for modernizing cooperative farming and attracting youth to agriculture.",
      thumbnail: "https://images.unsplash.com/photo-1523741543316-32a1620e139a?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      duration: "11:55",
      views: "12K",
      date: "2023-12-10",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ", // Replace with actual video
      category: "Interview",
      author: "Mastercard Foundation"
    }
  ];

  // Testimonials Data
  const testimonialsData = [
    {
      id: 1,
      name: "Abebech Alemu",
      role: "Mach Tulama",
      content: "Being part of the cooperative has transformed my life. I now have access to fair prices, training, and healthcare for my family.",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      rating: 5
    },
    {
      id: 2,
      name: "Tadesse Haile",
      role: "Dairy Cooperative Leader",
      content: "Our union of 15 cooperatives has created a thriving dairy business that serves thousands of families in Addis Ababa.",
      image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      rating: 5
    },
    {
      id: 3,
      name: "Meron Assefa",
      role: "Teff Farmer, Amhara",
      content: "The women's cooperative has given us a voice and economic independence. We're now exporting our teff to international markets.",
      image: "https://images.unsplash.com/photo-1557053910-d9eadeed1c58?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      rating: 5
    }
  ];

  // Quick stats for hero section
  const statsData = [
    { label: "Cooperative Unions", value: "327+", icon: FaUsers },
    { label: "Active Members", value: "1.5M+", icon: FaUserCircle },

    { label: "City Covered", value: "11", icon: FaMapMarkerAlt }
  ];

  // Navigation items
  const navItems = [
    { name: "Home", href: "#", id: "home" },
    { name: "News", href: "#news", id: "news" },
    { name: "Activities", href: "#activities", id: "activities" },
    { name: "Videos", href: "#videos", id: "videos" },
    { name: "Testimonials", href: "#testimonials", id: "testimonials" },
    { name: "Contact", href: "#contact", id: "contact" }
    
  ];




  // Handle scroll events
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);

      const sections = navItems.map(item => item.id);
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [navItems]);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'upcoming': return 'bg-blue-100 text-blue-800';
      case 'ongoing': return 'bg-green-100 text-green-800';
      case 'completed': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getTypeIcon = (type) => {
    switch(type) {
      case 'meeting': return <FaUsers className="w-4 h-4" />;
      case 'training': return <FaHandsHelping className="w-4 h-4" />;
      case 'workshop': return <FaSeedling className="w-4 h-4" />;
      case 'conference': return <FaUsers className="w-4 h-4" />;
      case 'exhibition': return <FaCoffee className="w-4 h-4" />;
      default: return <FaCalendarAlt className="w-4 h-4" />;
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen relative">
      {/* Animated Gradient Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-white to-green-400 animate-gradient-x"></div>
        <div className="absolute inset-0 bg-gradient-to-tr from-blue-300 via-transparent to-green-300 opacity-50 animate-gradient-y"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-200 via-transparent to-green-200 opacity-30"></div>
      </div>

      {/* Floating Elements */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-green-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000"></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <header className="bg-white/80 backdrop-blur-md shadow-md sticky top-0 z-50 border-b border-blue-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-20">
              {/* Logo */}
              <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-green-600 rounded-xl flex items-center justify-center shadow-lg transform hover:scale-105 transition-transform duration-200">
                    <span className="text-white font-bold text-LG px-4">C-ONE</span>
                  </div>
                </div>
                <div className="ml-3">
                  <h4 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                    Coperative<span className="text-green-600"> Online Network Enterprize</span>
                  </h4>

                </div>
              </div>

              {/* Desktop Navigation */}
              <nav className="hidden md:flex space-x-1">
                {navItems.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => scrollToSection(item.id)}
                    className={`${
                      activeSection === item.id
                        ? 'text-blue-600 bg-blue-50'
                        : 'text-gray-600 hover:text-green-600 hover:bg-green-50'
                    } px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200`}
                  >
                    {item.name}
                  </button>
                ))}
              </nav>

              {/* Mobile menu button */}
              <div className="md:hidden">
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="inline-flex items-center justify-center p-2 rounded-lg text-gray-600 hover:text-blue-600 hover:bg-blue-50 focus:outline-none transition-colors duration-200"
                >
                  {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-blue-100 animate-fadeIn">
              <div className="px-4 pt-2 pb-4 space-y-1">
                {navItems.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => scrollToSection(item.id)}
                    className={`${
                      activeSection === item.id
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-green-50 hover:text-green-600'
                    } block w-full text-left px-4 py-3 rounded-lg text-base font-medium transition-colors duration-200`}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            </div>
          )}
        </header>

        {/* Hero Banner Section */}
        <section id="home" className="relative overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 relative z-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="animate-slideUp">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                  <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                    Empowering Sheger
                  </span>
                  <br />
                  <span className="text-gray-800">Cooperatives Together</span>
                </h1>
                <p className="text-xl mb-8 text-gray-600 leading-relaxed">
                  Join 327+ cooperative unions and 1.5 million members working together 
                  for sustainable growth, prosperity, and community development across Ethiopia.
                </p>
                
                {/* CTA Buttons */}
                

                {/* Stats */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
                  {statsData.map((stat, index) => (
                    <div key={index} className="text-center group cursor-pointer bg-white/50 backdrop-blur-sm rounded-lg p-4 hover:bg-white/80 transition-all duration-200">
                      <div className="flex justify-center mb-2">
                        <stat.icon className="w-8 h-8 text-blue-600 group-hover:text-green-600 transition-colors duration-200" />
                      </div>
                      <div className="text-3xl font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-200">
                        {stat.value}
                      </div>
                      <div className="text-sm text-gray-600 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Hero Image */}
              <div className="hidden lg:block animate-fadeIn">
                <div className="relative">
                  <img
                    src="https://images.unsplash.com/photo-1523803326055-6d5d2a3e4d9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                    alt=""
                    className="rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute -bottom-4 -left-4 bg-white rounded-lg shadow-xl p-4">
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* News Section */}
        <section id="news" className="py-20 bg-white/70 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                  Latest News
                </span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Stay updated with the latest developments from cooperative unions in Sheger City
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {newsData.map((news) => (
                <article key={news.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={news.image}
                      alt={news.title}
                      className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                    />
                    <span className="absolute top-4 left-4 bg-gradient-to-r from-blue-600 to-green-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      {news.category}
                    </span>
                    <span className="absolute top-4 right-4 bg-black bg-opacity-50 text-white px-3 py-1 rounded-full text-xs flex items-center">
                      <FaRegClock className="mr-1" /> {news.readTime}
                    </span>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-500 mb-2">
                      <FaCalendarAlt className="mr-2" />
                      {formatDate(news.date)}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 hover:text-blue-600 transition-colors duration-200">
                      {news.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {news.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-500">
                        By {news.author}
                      </span>
                      <button className="text-blue-600 hover:text-green-600 font-semibold text-sm flex items-center group">
                        Read More 
                        <FaArrowRight className="ml-2 w-3 h-3 group-hover:translate-x-1 transition-transform duration-200" />
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            <div className="text-center mt-12">
              <button className="bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 transform hover:scale-105 transition-all duration-200 shadow-lg">
                View All News
              </button>
            </div>
          </div>
        </section>

        {/* Activities Section */}
        <section id="activities" className="py-20 bg-gradient-to-b from-white/50 to-transparent">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                  Recent & Upcoming Activities
                </span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Participate in events, training, and meetings organized by cooperative unions
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {activitiesData.map((activity) => (
                <div key={activity.id} className="bg-white/80 backdrop-blur-sm rounded-xl p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-blue-100">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center space-x-4">
                      <div className={`p-3 rounded-xl ${
                        activity.type === 'meeting' ? 'bg-blue-100 text-blue-600' :
                        activity.type === 'training' ? 'bg-green-100 text-green-600' :
                        activity.type === 'workshop' ? 'bg-yellow-100 text-yellow-600' :
                        activity.type === 'conference' ? 'bg-purple-100 text-purple-600' :
                        'bg-orange-100 text-orange-600'
                      }`}>
                        {getTypeIcon(activity.type)}
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900">
                          {activity.title}
                        </h3>
                        <span className={`inline-block mt-2 px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(activity.status)}`}>
                          {activity.status.charAt(0).toUpperCase() + activity.status.slice(1)}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                    {activity.description}
                  </p>

                  <div className="space-y-3 text-sm bg-white p-4 rounded-lg border border-blue-50">
                    <div className="flex items-center text-gray-600">
                      <FaCalendarAlt className="mr-3 text-blue-600" />
                      {formatDate(activity.date)} at {activity.time}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <FaMapMarkerAlt className="mr-3 text-green-600" />
                      {activity.location}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <FaUsers className="mr-3 text-blue-600" />
                      {activity.attendees.toLocaleString()} expected attendees
                    </div>
                  </div>

                
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <button className="bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 transform hover:scale-105 transition-all duration-200 shadow-lg">
                View Full Calendar
              </button>
            </div>
          </div>
        </section>

        {/* Videos Section */}
        <section id="videos" className="py-20 bg-white/70 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                  Featured Videos
                </span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Watch stories, documentaries, and training videos from Ethiopian cooperatives
              </p>
            </div>

            {/* Video Modal */}
            {activeVideo && (
              <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90 animate-fadeIn">
                <div className="relative w-full max-w-5xl">
                  <button
                    onClick={() => setActiveVideo(null)}
                    className="absolute -top-12 right-0 text-white hover:text-gray-300 flex items-center space-x-2 bg-black bg-opacity-50 px-4 py-2 rounded-lg"
                  >
                    <FaTimes size={20} />
                    <span>Close</span>
                  </button>
                  <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
                    <iframe
                      src={activeVideo}
                      className="w-full h-full"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {videosData.map((video) => (
                <div key={video.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="relative group cursor-pointer" onClick={() => setActiveVideo(video.videoUrl)}>
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-52 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/40 to-green-600/40 group-hover:opacity-75 transition-all duration-300 flex items-center justify-center">
                      <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center transform group-hover:scale-110 transition-all duration-300 shadow-xl">
                        <FaPlay className="w-6 h-6 text-blue-600 ml-1" />
                      </div>
                    </div>
                    <span className="absolute bottom-3 right-3 bg-black bg-opacity-75 text-white px-3 py-1 rounded-lg text-xs font-semibold">
                      {video.duration}
                    </span>
                    <span className="absolute top-3 left-3 bg-gradient-to-r from-blue-600 to-green-600 text-white px-3 py-1 rounded-lg text-xs font-semibold">
                      {video.category}
                    </span>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm text-gray-500 flex items-center">
                        <FaEye className="mr-1" /> {video.views} views
                      </span>
                      <span className="text-sm text-gray-500">
                        {formatDate(video.date)}
                      </span>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2 hover:text-blue-600 transition-colors duration-200">
                      {video.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                      {video.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-gray-500">
                        By {video.author}
                      </span>
                      <button 
                        onClick={() => setActiveVideo(video.videoUrl)}
                        className="text-blue-600 hover:text-green-600 text-sm font-semibold flex items-center group"
                      >
                        Watch Now 
                        <FaPlay className="ml-2 w-3 h-3 group-hover:translate-x-1 transition-transform duration-200" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <button className="bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 transform hover:scale-105 transition-all duration-200 shadow-lg">
                View More Videos
              </button>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section id="testimonials" className="py-20 bg-gradient-to-b from-transparent to-white/50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                  What Our Members Say
                </span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Real stories from cooperative members across Ethiopia
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {testimonialsData.map((testimonial) => (
                <div key={testimonial.id} className="bg-white/80 backdrop-blur-sm rounded-xl p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="flex items-center mb-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-16 h-16 rounded-full object-cover border-4 border-blue-600"
                    />
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                      <p className="text-sm text-gray-600">{testimonial.role}</p>
                    </div>
                  </div>
                  <div className="relative">
                    <FaQuoteRight className="absolute -top-2 -right-2 text-blue-200 text-4xl" />
                    <p className="text-gray-700 italic relative z-10">"{testimonial.content}"</p>
                  </div>
                  <div className="flex mt-4 text-yellow-400">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer id="contact" className="bg-gradient-to-r from-blue-900 to-green-900 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
              {/* About Section */}
              <div>
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
                    <span className="text-blue-600 font-bold text-xl">C-ONE</span>
                  </div>
                  <span className="ml-3 text-xl font-bold">Cooperatives Online Network Enterprize</span>
                </div>
                <p className="text-blue-100 mb-6 leading-relaxed">
                  Uniting 327+ cooperative unions across Ethiopia to foster sustainable growth, 
                  empower communities, and create prosperity for 1.5 million members.
                </p>
                <div className="flex space-x-4">
                  <a href="#" className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors duration-200">
                    <FaFacebook size={20} />
                  </a>
                  <a href="#" className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors duration-200">
                    <FaTwitter size={20} />
                  </a>
                  <a href="#" className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors duration-200">
                    <FaYoutube size={20} />
                  </a>
                  <a href="#" className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors duration-200">
                    <FaLinkedin size={20} />
                  </a>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
                <ul className="space-y-3">
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> About Us</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Our Unions</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Membership</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Resources</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> FAQs</a></li>
                </ul>
              </div>

              {/* Resources */}
              <div>
                <h3 className="text-lg font-semibold mb-6">Resources</h3>
                <ul className="space-y-3">
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Annual Reports</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Training Materials</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Policy Documents</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Success Stories</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-white transition-colors duration-200 flex items-center"><FaArrowRight className="mr-2 w-3 h-3" /> Photo Gallery</a></li>
                </ul>
              </div>

              {/* Contact Info */}
              <div>
                <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
                <ul className="space-y-4">
                  <li className="flex items-start space-x-3">
                    <FaMapMarkerAlt className="text-green-400 mt-1 flex-shrink-0" />
                    <span className="text-blue-100">
                      Bole Road, Dembel City Center<br />
                      4th Floor, Addis Ababa, Ethiopia
                    </span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <FaPhone className="text-green-400 flex-shrink-0" />
                    <span className="text-blue-100">+251 11 123 4567</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <FaEnvelope className="text-green-400 flex-shrink-0" />
                    <span className="text-blue-100">info@ethiopiancoops.et</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-blue-800 mt-12 pt-8">
              <div className="flex flex-col md:flex-row justify-between items-center">
                <p className="text-blue-200 text-sm">
                  © {new Date().getFullYear()} Ethiopian Cooperative Union Management System. All rights reserved.
                </p>
                <div className="flex space-x-6 mt-4 md:mt-0">
                  <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors duration-200">
                    Privacy Policy
                  </a>
                  <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors duration-200">
                    Terms of Service
                  </a>
                  <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors duration-200">
                    Cookie Policy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>

        {/* Back to Top Button */}
        {showBackToTop && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="fixed bottom-8 right-8 bg-gradient-to-r from-blue-600 to-green-600 text-white p-4 rounded-full shadow-xl hover:from-blue-700 hover:to-green-700 transform hover:scale-110 transition-all duration-200 z-40 animate-bounce"
          >
            <FaChevronUp className="w-5 h-5" />
          </button>
        )}
      </div>

      <style jsx>{`
        @keyframes gradient-x {
          0%, 100% { transform: translateX(0%); }
          50% { transform: translateX(100%); }
        }
        
        @keyframes gradient-y {
          0%, 100% { transform: translateY(0%); }
          50% { transform: translateY(100%); }
        }
        
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        
        .animate-gradient-x {
          animation: gradient-x 15s ease infinite;
          background-size: 400% 400%;
        }
        
        .animate-gradient-y {
          animation: gradient-y 15s ease infinite;
          background-size: 400% 400%;
        }
        
        .animate-blob {
          animation: blob 7s infinite;
        }
        
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out;
        }
        
        .animate-slideUp {
          animation: slideUp 0.5s ease-out;
        }
        
        .animate-bounce {
          animation: bounce 2s infinite;
        }
        
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
      `}</style>
    </div>
  );
};

export default Home;